import { useState, useEffect } from 'react';
import api from '../api/axios';
import i18n from '../i18n';

/**
 * Custom hook for managing agency-related data
 * Handles fetching agency info, cities, areas, and property types
 */
export const useAgencyData = () => {
    const [agency, setAgency] = useState(null);
    const [cities, setCities] = useState([]);
    const [areas, setAreas] = useState([]);
    const [propertyTypes, setPropertyTypes] = useState([]);

    const [systemConfig, setSystemConfig] = useState({
        currency: '',
        language: '',
        supportedCurrencies: []
    });

    const fetchAgency = async () => {
        try {
            const res = await api.get('/agencies/me');
            setAgency(res.data);
        } catch (err) {
            console.error('Failed to fetch agency:', err);
        }
    };

    const fetchCities = async () => {
        try {
            const res = await api.get('/locations/cities');
            setCities(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            console.error('Failed to fetch cities:', err);
            setCities([]);
        }
    };

    const fetchAreas = async (city) => {
        if (!city) {
            setAreas([]);
            return;
        }
        try {
            const res = await api.get('/tours/areas', { params: { city } });
            setAreas(res.data);
        } catch (err) {
            console.error('Failed to fetch areas:', err);
            setAreas([]);
        }
    };

    const fetchPropertyTypes = async () => {
        try {
            const res = await api.get('/locations/property-types');
            setPropertyTypes(res.data);
        } catch (err) {
            console.error('Failed to fetch property types:', err);
        }
    };

    const fetchSystemConfig = async () => {
        try {
            const res = await api.get('/locations/config');
            if (res.data) {
                setSystemConfig({
                    currency: res.data.currency,
                    language: res.data.language,
                    supportedCurrencies: res.data.supported_currencies || []
                });
            }
        } catch (err) {
            console.error('Failed to fetch system config:', err);
        }
    };

    useEffect(() => {
        fetchSystemConfig();
    }, []);

    return {
        agency,
        cities,
        areas,
        propertyTypes,
        systemConfig,
        fetchAgency,
        fetchCities,
        fetchAreas,
        fetchPropertyTypes,
        fetchSystemConfig
    };
};
